export default {"src":"/_next/static/media/SAFT.bcb524b7.svg","height":18,"width":18};